<div class="loader-wrapper" [class.overlay]="overlay()" [class.size-sm]="size() === 'sm'" [class.size-lg]="size() === 'lg'">
  <div class="loader-content">
    <div class="logo-container">
      <!-- Animated ring -->
      <svg class="ring-spinner" viewBox="0 0 100 100">
        <circle class="ring-track" cx="50" cy="50" r="46" />
        <circle class="ring-arc" cx="50" cy="50" r="46" />
      </svg>

      <!-- Logo icon: network graph -->
      <svg class="logo-icon" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="logoGrad" x1="0" y1="0" x2="56" y2="56" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="#43cea2"/>
            <stop offset="100%" stop-color="#0aaeff"/>
          </linearGradient>
        </defs>
        <rect width="56" height="56" rx="14" fill="url(#logoGrad)"/>

        <!-- Connection lines -->
        <g class="lines" stroke="rgba(255,255,255,0.5)" stroke-width="2" stroke-linecap="round">
          <line class="line line-1" x1="16" y1="36" x2="24" y2="22"/>
          <line class="line line-2" x1="24" y1="22" x2="36" y2="30"/>
          <line class="line line-3" x1="36" y1="30" x2="42" y2="18"/>
        </g>

        <!-- Nodes -->
        <g class="nodes">
          <circle class="node node-1" cx="16" cy="36" r="4.5" fill="white"/>
          <circle class="node node-2" cx="24" cy="22" r="5" fill="white"/>
          <circle class="node node-3" cx="36" cy="30" r="4.5" fill="white"/>
          <circle class="node node-4" cx="42" cy="18" r="5" fill="white"/>
        </g>
      </svg>
    </div>

    <!-- Loading dots -->
    <div class="loading-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>

    <p class="loader-message" *ngIf="message()">{{message()}}</p>
  </div>
</div>
